import { render, staticRenderFns } from "./freightTemplate.vue?vue&type=template&id=7ac9edf2&scoped=true&"
import script from "./freightTemplate.vue?vue&type=script&lang=js&"
export * from "./freightTemplate.vue?vue&type=script&lang=js&"
import style0 from "./freightTemplate.vue?vue&type=style&index=0&id=7ac9edf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac9edf2",
  null
  
)

component.options.__file = "freightTemplate.vue"
export default component.exports